import { Images, Trash2 } from "lucide-react";
import {
  receiptGroups,
  type ReceiptAttachment,
  appendReceiptFiles,
  receiptImageGroups,
} from "../lib/image-data";

export type { ReceiptAttachment };
export { appendReceiptFiles, receiptGroups, receiptImageGroups };

export default function ReceiptAttachments({
  items,
  onChange,
  disabled = false,
}: {
  items: ReceiptAttachment[];
  onChange: (items: ReceiptAttachment[]) => void;
  disabled?: boolean;
}) {
  const groups = receiptGroups(items);
  return (
    <section className="receipt-attachments" aria-label="Selected receipt photos">
      <div className="receipt-attachment-summary">
        <Images size={18} />
        <strong>{items.length} {items.length === 1 ? "photo" : "photos"}</strong>
        <span>· {groups.length} {groups.length === 1 ? "receipt" : "receipts"}</span>
      </div>
      {items.map((item, index) => {
        const group = groups.findIndex((group) => group.includes(item)) + 1;
        return (
          <div className="receipt-attachment" key={item.id}>
            <span><strong>Receipt {group}</strong><small>{item.file.name || `Photo ${index + 1}`}</small></span>
            {index > 0 && (
              <label>
                <input
                  type="checkbox"
                  checked={item.sameAsPrevious}
                  disabled={disabled}
                  onChange={(e) => onChange(items.map((v) => v.id === item.id ? { ...v, sameAsPrevious: e.target.checked } : v))}
                />
                Same receipt as photo above
              </label>
            )}
            <button
              type="button"
              aria-label={`Remove ${item.file.name || `photo ${index + 1}`}`}
              disabled={disabled}
              onClick={() => onChange(items.filter((v) => v.id !== item.id).map((v, i) => i === 0 ? { ...v, sameAsPrevious: false } : v))}
            >
              <Trash2 size={17} />
            </button>
          </div>
        );
      })}
      {items.length > 1 && <p>Turn on “Same receipt” for extra pages or overlapping photos. Leave it off when the next photo is a separate expense.</p>}
    </section>
  );
}
